if (!customElements.get("shipping-protection")) {
  customElements.define(
    "shipping-protection",
    class ShippingProtection extends HTMLElement {
      constructor() {
        super();
        this.status = this.getAttribute("data-status") || "false";
        this.switch = this.querySelector("[data-swich]");
        this.variantId = this.dataset.id;
        this.switch.addEventListener("click", this.handleSwitch.bind(this));
      }

      handleSwitch() {
        if (this.status == "true") {
          // 删除运费险
          console.log("删除运费险", this.status);
          this.removeShippingProtection();
        } else {
          // 添加运费险
          console.log("添加运费险", this.status);
          this.addShippingProtection();
        }
      }
      removeShippingProtection() {
        const formData = new FormData();
        formData.append(`updates[${this.variantId}]`, 0);

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((cart) => {
            this.switchOff();
            // update.js 已返回完整 cart，直接走 change（满赠）
            this.updateCart(cart);
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
      addShippingProtection() {
        const formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1,
            },
          ],
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            console.log(res);

            this.switchOn();
            this.updateCart();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
      switchOn() {
        this.status = "true";
        this.setAttribute("data-status", this.status);
        this.classList.add("on");
      }
      switchOff() {
        this.status = "false";
        this.setAttribute("data-status", this.status);
        this.classList.remove("on");
      }
      /**
       * @param {object} [cart] 已有完整 cart 时可传入，避免再 GET
       */
      async updateCart(cart) {
        if (!cart) {
          cart = await fetch(`${window.theme.routes.cart}.js`).then((r) => r.json());
        }
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: { cart },
            bubbles: true,
          })
        );
        // 运费险在抽屉内操作、不会 open；change 在无满赠变更时不 loadHTML，需 reload 刷行项目
        document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
      }
    }
  );
}
